// extracted by mini-css-extract-plugin
module.exports = {"windowModal":"WindowModal_windowModal__1t4V1"};